function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { getSizeValue, getStrokeWidth, getRotationTransform } from '../util';

function SvgAlertCircle(_ref) {
  var size = _ref.size,
      rotate = _ref.rotate,
      color = _ref.color,
      _ref$nonScalingStroke = _ref.nonScalingStroke,
      nonScalingStroke = _ref$nonScalingStroke === void 0 ? true : _ref$nonScalingStroke,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ["size", "rotate", "color", "nonScalingStroke", "style"]);

  var sizeValue = getSizeValue(size);
  var sizePx = sizeValue + 'px';

  var styles = _objectSpread({
    stroke: 'currentColor',
    fill: 'currentColor',
    strokeWidth: getStrokeWidth(sizeValue, nonScalingStroke),
    transform: getRotationTransform(rotate)
  }, style);

  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    stroke: "none",
    width: sizePx,
    height: sizePx,
    focusable: "false",
    color: color,
    style: styles
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75a.313.313 0 100 .625.313.313 0 000-.625h0m0-2.5V6.375",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.625a9.375 9.375 0 110 18.75 9.375 9.375 0 010-18.75z",
    fill: "none"
  })));
}

SvgAlertCircle.displayName = 'IconAlertCircle';
SvgAlertCircle.isIcon = true;
export default SvgAlertCircle;